import ApiUrl from "../../../configTools/api";
const User = JSON.parse(localStorage.getItem("user-info"));

const GetProduct = (setValues) => {
    fetch(ApiUrl.LabAdmin_Product,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
    });
}


const PostProduct = (body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Product,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            GetProduct(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const GetProductService = (setValues) => {
    fetch(ApiUrl.LabAdmin_Product_Service,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
    });
}

const GetProductServiceByProduct = (id,setValues) => {
    fetch(ApiUrl.LabAdmin_Product_Service+"/"+id,{
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        setValues(data.response);
    });
}


const PostProductService = (body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Product_Service,{
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Added", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            GetProductService(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const PutProductService = (id,body,setValues,toast,toastid,reset) => {
    fetch(ApiUrl.LabAdmin_Product_Service+"/"+id,{
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        },
        body: JSON.stringify(body)
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Updated", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            GetProductService(setValues);
            reset();
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

const DeleteProductService = (id,setValues,toast,toastid) => {
    fetch(ApiUrl.LabAdmin_Product_Service+"/"+id,{
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer '+User.token
        }
    })
    .then(res=>res.json())
    .then(data =>{
        if(data.success){
            setTimeout(() => {
              toast.update(toastid, { render: "Deleted", type: "success", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
            GetProductService(setValues);
        }
        else{
            setTimeout(() => {
              toast.update(toastid, { render: data.response, type: "error", isLoading: false, autoClose:2000, position: toast.POSITION.BOTTOM_CENTER });
            }, 500);
        }
    });
}

export default {GetProduct, PostProduct, GetProductService, GetProductServiceByProduct, PostProductService, PutProductService, DeleteProductService};